/*
  this is the "head" entry point for webpack
  files imported here are compiled into head.js or head.css
  see webpack.config.js for configuration
*/

// VENDOR STUFF
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
import Cookies from 'js-cookie';
window.Cookies = Cookies;
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

// OUR STUFF
window.idx = {};
